export default "__VITE_ASSET___VZ6$rD9__"